import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import '@/styles/index.less'
import 'normalize.css/normalize.css'
import '@/plugins/elementui'
import { getStudents } from "@/utils/students";
import { title } from "@/config";

Vue.config.productionTip = false


router.beforeEach((to, from, next) => {
  if (to.meta.isSearch) {
    let students = getStudents();
    if (!students || students.length == 0) {
      window.location.href = "/home";
      return
    }
  }
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  } else {
    document.title = title
  }
  next()
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
